import { Option } from "@/components/types/option";

export type OptionFieldsConfig<TValue extends Option> = {
  dataKey: string | ((opt: TValue) => string | number);
  optionLabel?: string;
  optionValue?: keyof TValue;
};

export class Divider {}
